import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["component"];
import React from 'react';
import { BoxImpl } from './BoxImpl';

/**
 * `<Box>` is the foundational component of Currency. It exposes a responsive, props-based API for applying styles from [`@nerdwallet/base-styles`](https://github.com/NerdWallet/base-styles) to components.
 */
export var Box = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$component = _ref.component,
      component = _ref$component === void 0 ? 'div' : _ref$component,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(BoxImpl, _extends({}, props, {
    component: component,
    ref: ref
  }));
});